module.exports = __webpack_public_path__ + "img/energy-campus.01a2ea56.png";